import { useState } from 'react';
// @mui
import { MenuItem, Stack } from '@mui/material';
// locales
// components
import { useTranslation } from 'react-i18next';
import { BaseImage, MenuPopover } from '@mgm/common/components/base';
import { IconButtonAnimate } from '@mgm/common/components/animate';

// ----------------------------------------------------------------------

const LanguagePopover = () => {
  const { i18n, t } = useTranslation('common');

  const ALL_LANGS = [
    {
      label: t('english'),
      value: 'en',
      icon: '/static/flags/ic_flag_us.svg',
    },
    {
      label: t('spanish'),
      value: 'es',
      icon: '/static/flags/ic_flag_es.svg',
    },
  ];

  const DEFAULT_LANG = ALL_LANGS[0];

  const [openPopover, setOpenPopover] = useState<HTMLElement | null>(null);

  const currentLang = ALL_LANGS.find((_lang) => _lang.value === i18n.language) || DEFAULT_LANG;

  const handleOpenPopover = (event: React.MouseEvent<HTMLElement>) => {
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  const handleChangeLang = (newLang: string) => {
    i18n.changeLanguage(newLang);
    handleClosePopover();
  };

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpenPopover}
        sx={{
          width: 40,
          height: 40,
          ...(openPopover && {
            bgcolor: 'action.selected',
          }),
        }}
      >
        <BaseImage disabledEffect src={currentLang.icon} alt={currentLang.label} />
      </IconButtonAnimate>

      <MenuPopover open={openPopover} onClose={handleClosePopover} sx={{ width: 180 }}>
        <Stack spacing={0.75}>
          {ALL_LANGS.map((option) => (
            <MenuItem
              key={option.value}
              selected={option.value === currentLang.value}
              onClick={() => handleChangeLang(option.value)}
            >
              <BaseImage
                disabledEffect
                alt={option.label}
                src={option.icon}
                sx={{ width: 28, mr: 2 }}
              />

              {option.label}
            </MenuItem>
          ))}
        </Stack>
      </MenuPopover>
    </>
  );
};

export {
  LanguagePopover,
};
